import React from 'react'
import { additionalLegsColumns, additionalLegsColumnsMobile } from './column'
import { DataGridPro, DataGridProProps, useGridApiRef } from '@mui/x-data-grid-pro'
import { Box, Breakpoint, Typography, alpha, useTheme } from '@mui/material';
import { IParlayOutcome, IShopOutcome, IShopOutcomesPagination, Leagues } from '../pick6/store/types';
import { APIState } from '../utils/api/reducer';
import { GetLayout, Layout } from './store/types';
import SelectComponent from './Select';
import { APIConstants } from '../utils/api/constants';


const NoRowsOverlay = (leagues: Leagues[]) => {
  if (leagues && leagues.length === 1 && leagues[0] !== Leagues.ALL) {
    return (
      <Box display={'flex'} flexDirection={'row'} alignItems={'center'} justifyContent={'center'} textAlign={'center'} height={'100%'}>
        <Typography>
          No Bets Available, please adjust your filters and try again. Or checkout other <a href={`/odds/shop/${leagues[0].toLowerCase()}`} style={{ textDecoration: 'underline' }}>{leagues[0].toString()} bets and odds</a>
        </Typography>
      </Box>
    );
  }
  return (
    <Box display={'flex'} flexDirection={'row'} alignItems={'center'} justifyContent={'center'} textAlign={'center'} height={'100%'}>
      <Typography>
        No Bets Available, please adjust your filters and try again.
      </Typography>
    </Box>
  );
};

interface OwnProps {
  additionalLegs: APIState<{
    outcomes: IShopOutcome[];
    pagination: Partial<IShopOutcomesPagination>;
  }>;
  getType: (o: IShopOutcome) => 'Add' | 'Swap' | 'Remove';
  handleLegClick: (o: IParlayOutcome) => void;
  isDisplayUnlocked: boolean;
  isPickemTable: boolean;
  width: Breakpoint;
  defaultSort: string;
  tableProps?: Partial<DataGridProProps>;
}

type Props = OwnProps;

const AdditionalLegsTable = (props: Props) => {
  const { additionalLegs, isDisplayUnlocked, defaultSort, isPickemTable, tableProps, getType, handleLegClick } = props;


  let gridData = additionalLegs?.data?.outcomes ?? [];

  const layout = GetLayout();

  const theme = useTheme();

  const apiRef = useGridApiRef();

  const handleSort = (sort: any) => {
    apiRef.current.sortColumn({ field: sort.field, sortable: true }, sort.direction, false);
  }

  return (
    <>
      {
        layout !== Layout.Desktop && (
          <>
            <Box marginBottom="16px">
              <SelectComponent
                backgroundColorOverride={'#1C1C1C'}
                options={additionalLegsColumnsMobile(getType, handleLegClick, isDisplayUnlocked).filter(x => x.field).flatMap(x => [{ ...x, direction: 'desc' }, { ...x, direction: 'asc' }])}
                label={'Sort By'}
                getMenuItemLabel={(item) => `${item.headerName} - ${item.direction?.toUpperCase()}`}
                getValue={(item) => ({ field: item.field, direction: item.direction })}
                handleClick={handleSort}
              />
            </Box>
            <DataGridPro
              apiRef={apiRef}
              columns={additionalLegsColumnsMobile(getType, handleLegClick, isDisplayUnlocked, isPickemTable)}
              rows={gridData}
              getRowId={(row) => row?.outcomeId}
              scrollbarSize={0}
              rowSelection={false}
              loading={additionalLegs.status !== APIConstants.SUCCEEDED}
              // hideFooter={true}
              columnHeaderHeight={0}
              rowHeight={130}
              disableColumnMenu
              // sortModel={sortModel}
              // onSortModelChange={(newSortModel) => console.log('newSort', newSortModel)}
              initialState={{
                sorting: {
                  sortModel: [{ field: defaultSort, sort: 'desc' }],
                },
                columns: {
                  columnVisibilityModel: {
                    // Hide columns status and traderName, the other columns will remain visible
                    oddsAmerican: false,
                    sev: false,
                    expectedRoiPct: false,
                    expectedWinPct: false,
                  },
                },
              }}
              sx={{
                border: 'none',
                '& .MuiDataGrid-withBorderColor': {
                  border: 'none',
                },
                '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
                  width: '0px',
                  height: 14,
                  padding: 8,
                },
                '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track': {
                  background: 'transparent',
                },
                '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
                  backgroundColor: '#122A4A',
                  borderRadius: 4,
                  borderTop: '3px transparent solid',
                  borderBottom: '3px transparent solid',
                  backgroundClip: 'padding-box',
                },
                '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover': {
                  backgroundColor: '#122A4A',
                  borderRadius: 4,
                  borderTop: '3px transparent solid',
                  borderBottom: '3px transparent solid',
                  backgroundClip: 'padding-box',
                },
                '& .MuiDataGrid-cell': {
                  padding: 0,
                },
                '& .MuiDataGrid-footerContainer': {
                  justifyContent: 'center',
                  '& .MuiTablePagination-root': {
                    color: 'white',
                  }
                }
              }}
              {...tableProps}
            />
          </>
        )
      }
      {layout === Layout.Desktop && (
        <DataGridPro
          columns={additionalLegsColumns(getType, handleLegClick, isDisplayUnlocked, isPickemTable).filter(x => isPickemTable ? !(['sev', 'evAge', 'suggestedBet'].indexOf(x.field) > -1) : true)}
          rows={gridData}
          getRowId={(row) => row?.outcomeId}
          showCellVerticalBorder
          scrollbarSize={0}
          rowSelection={false}
          // showColumnVerticalBorder
          loading={additionalLegs.status !== APIConstants.SUCCEEDED}
          // hideFooter={true}
          // columnHeaderHeight={layout == Layout.Desktop ? 0 : 36}
          // rowHeight={64}
          getRowHeight={() => 'auto'}
          disableColumnMenu
          slots={{
            noRowsOverlay: NoRowsOverlay
          }}
          initialState={{
            sorting: {
              sortModel: [{ field: defaultSort, sort: 'desc' }],
            },
          }}
          sx={{
            color: 'white',
            height: '100%',
            border: 'none',
            borderRadius: '10px',
            backgroundColor: alpha("#1C1C1C", .5),
            '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
              width: '0px',
              height: 14,
              padding: 8,
            },
            '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track': {
              background: 'transparent',
            },
            '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
              backgroundColor: '#122A4A',
              borderRadius: 4,
              borderTop: '3px transparent solid',
              borderBottom: '3px transparent solid',
              backgroundClip: 'padding-box',
            },
            '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#122A4A',
              borderRadius: 4,
              borderTop: '3px transparent solid',
              borderBottom: '3px transparent solid',
              backgroundClip: 'padding-box',
            },
            '& .MuiDataGrid-sortIcon': {
              color: 'white',
            },
            '& .MuiDataGrid-row:nth-child(even)': {
              backgroundColor: { md: '#101010' },
              '& .MuiDataGrid-row.Mui-hovered': {
                backgroundColor: '#101010'
              },
            },
            '& .MuiDataGrid-cellContent': {
              fontWeight: 400,
            },
            '& .MuiDataGrid-columnHeader': {
              backgroundColor: '#101010',
              color: alpha(theme.palette.common.white, 0.7),
              fontWeight: 500,
              fontSize: 12,
              padding: '10px 8px',
            },
            '& .MuiDataGrid-root': {
              border: 'none !important',
              borderRadius: '10px'
            },
            '& .MuiDataGrid-main': {
              border: 'none !important',
              borderRadius: '10px',
            },
            '& .MuiDataGrid-cell': {
              paddingTop: '12px',
              paddingBottom: '12px',
            },
            '& .osrating': {
              borderRadius: '6px 0px 0px 0px',
              background: 'linear-gradient(90deg, #00723B 0%, #004E28 100%)',
              '& .MuiDataGrid-columnHeaderTitle': {
                color: 'white',
                fontWeight: 700,
              }
            },
            '& .osratingCell': {
              padding: 0,
            },
            '& .ev': {
              borderRadius: '0px 6px 0px 0px',
              background: 'linear-gradient(90deg, #004E28 0%, #002E18 100%)',
              '& .MuiDataGrid-columnHeaderTitle': {
                color: 'white',
                fontWeight: 700,
              }
            },
            '& .evCell': {
              padding: 0,
            },
            "& .MuiDataGrid-row.Mui-hovered, .MuiDataGrid-row:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.08)",
            },
            '& .bet-row-hidden': {
              color: alpha(theme.palette.common.white, 0.5 * 0.87),
            },
            '& .MuiTablePagination-root': {
              color: 'white',
            }
          }}
          {...tableProps}
        />
      )
      }
    </>
  )
}

export default AdditionalLegsTable